import { FileReference } from '@kaizenplatform/belfast-entity';
import { AnyFieldValue } from '@kaizenplatform/hugot-entity';
import { ClassAttributes, createElement } from 'react';

import {
  DynamicSchemaDefinitionField,
  DynamicSchemaDefinitionFixed,
  DynamicSchemaDefinitionSelectMultiple,
  DynamicSchemaDefinitionSelectOne,
  DynamicSchemaDefinitionToggle,
} from '../../../../../generated/graphql';
import AsFiles from './AsFiles';
import AsMultipleSelection from './AsMultipleSelection';
import AsPlainText from './AsPlainText';
import AsSelection from './AsSelection';
import AsToggle from './AsToggle';

interface Props {
  field: DynamicSchemaDefinitionField;
  value: AnyFieldValue;
  files?: FileReference[];
  latestValue: AnyFieldValue;
  beforeValue: AnyFieldValue;
  latestFiles?: FileReference[];
  beforeFiles?: FileReference[];
  className?: string;
}

const Field = ({
  field,
  value,
  files,
  latestValue,
  beforeValue,
  latestFiles,
  beforeFiles,
  className,
}: ClassAttributes<HTMLElement> & Props) => {
  if (field.type === 'SINGLE_LINE_TEXT' || field.type === 'MULTI_LINE_TEXT' || field.type === 'POSITIVE_INTEGER') {
    return (
      <AsPlainText
        field={field}
        value={value as any}
        latestValue={latestValue as any}
        beforeValue={beforeValue as any}
        className={className}
      />
    );
  }

  if (field.type === 'FIXED') {
    const _field = field as DynamicSchemaDefinitionFixed;
    return (
      <AsPlainText
        field={_field}
        value={_field.value}
        latestValue={latestValue as any}
        beforeValue={beforeValue as any}
        className={className}
      />
    );
  }

  if (field.type === 'SELECT_ONE') {
    const _field = field as DynamicSchemaDefinitionSelectOne;
    return (
      <AsSelection
        field={_field}
        value={value as any}
        latestValue={latestValue as any}
        beforeValue={beforeValue as any}
        className={className}
      />
    );
  }

  if (field.type === 'SELECT_MULTIPLE') {
    const _field = field as DynamicSchemaDefinitionSelectMultiple;
    return (
      <AsMultipleSelection
        field={_field}
        value={value as any}
        latestValue={latestValue as any}
        beforeValue={beforeValue as any}
        className={className}
      />
    );
  }

  if (field.type === 'TOGGLE') {
    const _field = field as DynamicSchemaDefinitionToggle;
    return (
      <AsToggle
        field={_field}
        value={value as any}
        latestValue={latestValue as any}
        beforeValue={beforeValue as any}
        className={className}
      />
    );
  }

  if (field.type === 'FILES') {
    return (
      <AsFiles
        field={field}
        bucketId={value as string}
        beforeBucketId={beforeValue as string}
        latestBucketId={latestValue as string}
        files={files!}
        beforeFiles={beforeFiles!}
        latestFiles={latestFiles!}
        className={className}
      />
    );
  }

  return null;
};

export default Field;
